module.exports = __webpack_public_path__ + "static/layering-tangent-f564c85b4b53fd2f9da8daadfdbfbbd1.png";